module.exports = function(column) {
  return this.query.hasOwnProperty(column) &&
        this.opts.listColumns.hasOwnProperty(column);
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/methods/is-list-filter.js